import { render, staticRenderFns } from "./SubFeeDetails.vue?vue&type=template&id=008b0bee&scoped=true&"
import script from "./SubFeeDetails.vue?vue&type=script&lang=js&"
export * from "./SubFeeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b0bee",
  null
  
)

export default component.exports